import { Component } from '@angular/core';

@Component({
  selector: 'split-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent {}
